export const PREFERENCES: string[] = ["straight", "gay", "lesbian", "trans", "bisexual", "animated"];
